import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class KozDokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    Brfak: string;
    Datfak: NgbDate;
    Datdpo: NgbDate;
    Iznos: number;
    //OrgJedSifra: string;
    //OrgJedNaziv: string;

    Deserialize(input:any){
        this.ID=input.ID;        
        this.Brfak=input.Brfak;
        this.Datfak=input.Datfak;
        this.Datdpo=input.Datdpo;
        this.Iznos=input.Iznos;
       // this.OrgJedSifra=input.OrgJedSifra;
       // this.OrgJedNaziv=input.OrgJedNaziv;
        return this;
    }

    Serialize(input:KozDokumentStavkaView){
        return input;
    }
}